<template>
  <div>
    <a-tabs default-active-key="course" @change="tabChange">
      <a-tab-pane key="course" tab="课堂作业">
        <a-spin tip="Loading..." :spinning="spinning1">
          <a-row v-for="work in mineCourseWork" :key="work.id">
            <a-col :span="8">
              <img :src="work.mineWorkCover_url || work.workCover_url" alt="" />
            </a-col>
            <a-col :span="10">
              <a class="title" href="#"
                >{{ work.unitName }}
                {{ work.mediaType === 3 ? "课堂案例" : "作业案例" }}</a
              >
              <p class="meta">班级：{{ work.departName }}</p>
              <p class="meta">类型：{{ work.codeType_dictText }}</p>
              <p class="meta">
                状态：{{ work.mineWorkStatus_dictText || "未提交" }}
              </p>
            </a-col>
            <a-col :span="6">
              <div class="btn-wrapper">
                <a-button
                  v-if="work.mineWorkStatus == null"
                  type="primary"
                  @click="toCourseWork(work)"
                  >做作业</a-button
                >
                <a-button
                  v-if="work.mineWorkStatus !== null"
                  :disabled="work.mineWorkStatus > 1"
                  type="primary"
                  @click="toCourseWork(work)"
                  >修改作业</a-button
                >
                <!-- <a-button
                  v-if="work.mineWorkStatus === 0"
                  type="default"
                  @click="resetWork(work.mineWorkId)"
                  >重置</a-button
                > -->
              </div>
            </a-col>
          </a-row>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane key="additional" tab="自定义作业">
        <a-spin tip="Loading..." :spinning="spinning2">
          <a-row v-for="work in mineAdditionalWork" :key="work.id">
            <a-col :span="8">
              <img :src="work.mineWorkCover_url || work.workCover_url" alt="" />
            </a-col>
            <a-col :span="10">
              <a class="title" href="#">{{ work.workName }}</a>
              <p class="meta">班级：{{ work.departName }}</p>
              <p class="meta">{{ work.workDesc }}</p>
            </a-col>
            <a-col :span="6">
              <div class="btn-wrapper">
                <a-button
                  v-if="work.mineWorkStatus == null"
                  type="primary"
                  @click="toAdditionalWork(work, false)"
                  >做作业</a-button
                >
                <a-button
                  v-if="work.mineWorkStatus !== null"
                  :disabled="work.mineWorkStatus > 1"
                  type="primary"
                  @click="toAdditionalWork(work, false)"
                  >修改作业</a-button
                >
                <a-button
                  v-if="work.mineWorkStatus === 0"
                  type="default"
                  @click="resetWork(work.mineWorkId)"
                  >重置</a-button
                >
              </div>
            </a-col>
          </a-row>
        </a-spin>
      </a-tab-pane>
      <div slot="tabBarExtraContent">
        <a-select
          @change="statusChange"
          v-model="queryParam.submit"
          style="width: 100px"
        >
          <a-select-option key="1" value="true">已提交</a-select-option>
          <a-select-option key="2" value="false">未提交</a-select-option>
        </a-select>
      </div>
    </a-tabs>
  </div>
</template>

<script>
import { mineWorkList, delMyWork } from "@/api/community";
import { mineCourseWork, mineAdditionalWork } from "@/api/course";
export default {
  name: "StudentWork",
  data() {
    return {
      scene: "course",
      workStatus: "",
      queryParam: {
        submit: "false",
      },
      spinning1: true,
      spinning2: true,
      mineCourseWork: [],
      mineAdditionalWork: [],
    };
  },
  created() {
    this.getMineCourseWork();
  },
  methods: {
    getMineWork() {
      mineWorkList({
        scene: this.scene,
        workStatus: this.workStatus,
      }).then((res) => {});
    },
    getMineCourseWork() {
      mineCourseWork(this.queryParam).then((res) => {
        if (res.success) {
          this.mineCourseWork = res.result;
        }
        this.spinning1 = false;
      });
    },
    getMineAdditionalWork() {
      mineAdditionalWork(this.queryParam).then((res) => {
        this.spinning2 = false;
        if (res.success) {
          this.mineAdditionalWork = res.result;
        }
      });
    },
    resetWork(workId) {
      var that = this;
      this.$confirm({
        content: "是否重置作业素材？建议将之前的作业下载备份",
        onOk() {
          delMyWork(workId).then((res) => {
            if (res.success) {
              that.$message.success("重置成功");
              that.loadList();
            }
          });
        },
      });
    },
    toAdditionalWork(item, reset) {
      var workUrl;
      switch (item.codeType) {
        case 1:
          workUrl =
            "/scratch3/index.html?scene=additional&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName +
            "&workFile=" +
            (reset || item.mineWork_url == null
              ? item.workUrl
              : item.mineWork_url);
          break;
        case 2:
          workUrl =
            "/scratch3/index.html?scene=additional&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName +
            "&workFile=" +
            (reset || item.mineWork_url == null
              ? item.workUrl
              : item.mineWork_url);
          break;
        case 3:
          workUrl =
            "/scratchjr/editor.html?scene=additional&mode=edit&filepath=" +
            (reset || item.mineWork_url == null
              ? item.workUrl
              : item.mineWork_url);
          break;
        case 4:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=turtle&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName +
            "&workFile=" +
            (reset || item.mineWork_url == null
              ? item.workUrl
              : item.mineWork_url);
          break;
        case 5:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=python&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName +
            "&workFile=" +
            (reset || item.mineWork_url == null
              ? item.workUrl
              : item.mineWork_url);
          break;
        case 6:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=c&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName +
            "&workFile=" +
            (reset || item.mineWork_url == null
              ? item.workUrl
              : item.mineWork_url);
          break;
        case 7:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=cpp&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName +
            "&workFile=" +
            (reset || item.mineWork_url == null
              ? item.workUrl
              : item.mineWork_url);
          break;
        case 8:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=java&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName +
            "&workFile=" +
            (reset || item.mineWork_url == null
              ? item.workUrl
              : item.mineWork_url);
          break;
        default:
          workUrl = item.workUrl;
      }
      window.open(workUrl);
    },
    toCourseWork(item) {
      var workUrl;
      switch (item.codeType) {
        case 1:
          workUrl =
            "/scratch3/index.html?unitId=" +
            item.unitId +
            "&mediaId=" +
            item.mediaId +
            // (reset || item.mineWorkId == null
            //   ? "" : "&workId=" + item.mineWorkId) +
            "&departId=" +
            item.departId;
          break;
        case 2:
          workUrl =
            "/scratch3/index.html?unitId=" +
            item.unitId +
            "&mediaId=" +
            item.mediaId +
          //  (reset || item.mineWorkId == null
          //     ? "" : "&workId=" + item.mineWorkId) +
            "&departId=" +
            item.departId;
          break;
        case 3:
          workUrl =
            "/scratchjr/editor.html?mode=edit&filepath=" + item.workFile_url;
          break;
        case 4:
          workUrl =
            "/onlinecode/index.html?lang=turtle&unitId=" +
            item.unitId +
            "&mediaId=" +
            item.mediaId +
            // (reset || item.mineWorkId == null
            //   ? "" : "&workId=" + item.mineWorkId) +
            "&departId=" +
            item.departId;
          break;
        case 5:
          workUrl =
            "/onlinecode/index.html?lang=python&unitId=" +
            item.unitId +
            "&mediaId=" +
            item.mediaId +
            // (reset || item.mineWorkId == null
            //   ? "" : "&workId=" + item.mineWorkId) +
            "&departId=" +
            item.departId;
          break;
        case 6:
          workUrl =
            "/onlinecode/index.html?lang=c&unitId=" +
            item.unitId +
            "&mediaId=" +
            item.mediaId +
            // (reset || item.mineWorkId == null
            //   ? "" : "&workId=" + item.mineWorkId) +
            "&departId=" +
            item.departId;
          break;
        case 7:
          workUrl =
            "/onlinecode/index.html?lang=cpp&unitId=" +
            item.unitId +
            "&mediaId=" +
            item.mediaId +
            // (reset || item.mineWorkId == null
            //   ? "" : "&workId=" + item.mineWorkId) +
            "&departId=" +
            item.departId;
          break;
        case 8:
          workUrl =
            "/onlinecode/index.html?lang=java&unitId=" +
            item.unitId +
            "&mediaId=" +
            item.mediaId +
            // (reset || item.mineWorkId == null
            //   ? "" : "&workId=" + item.mineWorkId) +
            "&departId=" +
            item.departId;
          break;
        default:
          workUrl = item.workFile_url;
      }
      workUrl = workUrl + "&scene=course";
      window.open(workUrl);
    },
    tabChange(key) {
      this.scene = key;
      this.loadList();
    },
    loadList() {
      if (this.scene == "course") {
        this.getMineCourseWork();
      } else {
        this.getMineAdditionalWork();
      }
    },
    statusChange(key) {
      console.log(key);
      this.loadList();
    },
  },
};
</script>

<style lang="less" scoped>
.ant-row {
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  transition: all 0.1s ease-in;
  .ant-col {
    height: 128px;
    img {
      height: 100%;
      max-width: 100%;
    }
    .title {
      display: block;
      margin-top: 20px;
      font-size: 16px;
      line-height: 20px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .meta {
      margin-top: 8px;
      font-size: 12px;
      line-height: 16px;
      color: #999;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.ant-row:hover {
  border: 1px solid var(--primary-color);
}
.btn-wrapper {
  button {
    display: inline-block;
    margin-right: 10px;
  }
  margin-top: 50px;
}
</style>